import actions from "./actions";

const {
    SAVE_DRAFT,
    FETCH_DRAFTS,
    FETCH_DRAFT_BY_ID,
    DELETE_DRAFT,
    DISCARD_DRAFT_ATTACHMENT,
    RESET_DRAFT_FORM
} = actions;

const initState = {
    drafts: {
        data: [],
        pagination: {
            total: 0,
            page: 1,
            limit: 20,
            pages: 0
        }
    },
    currentDraft: null,
    saving: false
};

const TeacherEmailDraftReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_DRAFTS: {
            // Handles both response patterns safely:
            // 1. data = { data: { drafts: [...], pagination: {...} } }
            // 2. data = { drafts: [...], pagination: {...} }
            const draftsList = data?.data?.drafts || data?.drafts || [];
            const paginationInfo = data?.data?.pagination || data?.pagination || initState.drafts.pagination;

            return {
                ...state,
                drafts: {
                    data: draftsList,
                    pagination: paginationInfo
                }
            };
        }

        case FETCH_DRAFT_BY_ID:
            return {
                ...state,
                currentDraft: data?.data || data || null
            };

        case SAVE_DRAFT: {
            const savedDraft = data?.data || data;
            if (!savedDraft || !savedDraft._id) return state;

            // Check if draft already exists in state
            const existingIndex = state.drafts.data.findIndex(
                (item) => item._id === savedDraft._id
            );

            let updatedList = [...state.drafts.data];
            let isNewDraft = false;

            if (existingIndex !== -1) {
                // Update existing draft in list
                updatedList[existingIndex] = savedDraft;
            } else {
                // Prepend newly created draft
                updatedList = [savedDraft, ...updatedList];
                isNewDraft = true;
            }

            return {
                ...state,
                drafts: {
                    ...state.drafts,
                    data: updatedList,
                    pagination: {
                        ...state.drafts.pagination,
                        total: isNewDraft
                            ? state.drafts.pagination.total + 1
                            : state.drafts.pagination.total
                    }
                },
                currentDraft: savedDraft
            };
        }

        case DELETE_DRAFT: {
            const draftId = data;
            const filteredList = state.drafts.data.filter(
                (item) => item._id !== draftId
            );

            return {
                ...state,
                drafts: {
                    ...state.drafts,
                    data: filteredList,
                    pagination: {
                        ...state.drafts.pagination,
                        total: Math.max(0, state.drafts.pagination.total - 1)
                    }
                },
                currentDraft:
                    state.currentDraft?._id === draftId
                        ? null
                        : state.currentDraft
            };
        }

        case DISCARD_DRAFT_ATTACHMENT: {
            const { draftId, attachmentId } = data || {};

            // Remove attachment from current active draft if loaded
            let updatedCurrentDraft = state.currentDraft;
            if (
                updatedCurrentDraft &&
                updatedCurrentDraft._id === draftId &&
                Array.isArray(updatedCurrentDraft.attachments)
            ) {
                updatedCurrentDraft = {
                    ...updatedCurrentDraft,
                    attachments: updatedCurrentDraft.attachments.filter(
                        (att) => (att._id || att.uid) !== attachmentId
                    )
                };
            }

            // Remove attachment from drafts list item
            const updatedDraftsList = state.drafts.data.map((draft) => {
                if (draft._id === draftId && Array.isArray(draft.attachments)) {
                    return {
                        ...draft,
                        attachments: draft.attachments.filter(
                            (att) => (att._id || att.uid) !== attachmentId
                        )
                    };
                }
                return draft;
            });

            return {
                ...state,
                drafts: {
                    ...state.drafts,
                    data: updatedDraftsList
                },
                currentDraft: updatedCurrentDraft
            };
        }

        case RESET_DRAFT_FORM:
            return {
                ...state,
                currentDraft: null
            };

        default:
            return state;
    }
};

export default TeacherEmailDraftReducer;